import { supabase } from './supabase'

export async function syncBinance(apiKey, apiSecret) {
  const { data, error } = await supabase.functions.invoke('sync-binance', {
    body: { apiKey, apiSecret }
  })
  if (error) throw new Error(error.message)
  if (data.error) throw new Error(data.error)
  return data.trades
}

export async function syncBybit(apiKey, apiSecret) {
  const { data, error } = await supabase.functions.invoke('sync-bybit', {
    body: { apiKey, apiSecret }
  })
  if (error) throw new Error(error.message)
  if (data.error) throw new Error(data.error)
  return data.trades
}
